
function GetStarted() {
  return (
    <div className="bg-deep-purple py-8 flex flex-col items-center md:mt-4">
      <h3 className="text-white md:text-lg lg:text-2xl">
        Ready to get Started?
      </h3>
      <button className="text-white bg-light-purple mt-4 text-sm px-6 py-2 rounded-3xl md:mt-6 md:px-6 md:text-base lg:mt-8 lg:text-lg lg:px-10">
        <a href="/">Sign In</a>
      </button>
    </div>
  );
}

export default GetStarted